import {
  getShiftOperationalSummary,
} from "../core/shifts/shiftOperationalSummary";


export function toMillis(value) {
  if (!value) return NaN;

  try {
    if (typeof value?.toDate === "function") return value.toDate().getTime();
    if (typeof value === "number") return value;
    if (value?.seconds) return value.seconds * 1000;

    return new Date(value).getTime();
  } catch {
    return NaN;
  }
}

export function buildShiftMetrics(shifts = [], options = {}) {
  const {
    selectedDayMs = Date.now(),
    startOfDayMs,
    ymd,
  } = options;


  const isSameSelectedDay = (s) => {
    if (!startOfDayMs || !ymd) return true;

    const st = toMillis(s.startTime);
    if (!Number.isFinite(st)) return false;

    const end = toMillis(s.endTime);
const selectedStart = startOfDayMs(selectedDayMs);
const selectedEnd = selectedStart + 24 * 60 * 60 * 1000;

return (
  Number.isFinite(end) &&
  st < selectedEnd &&
  end > selectedStart
);
  };

  const rows = shifts.filter(isSameSelectedDay);

   const operationalRows =
    rows.map((shift) => ({
      shift,
      summary:
        getShiftOperationalSummary(
          shift
        ),
    }));

  const completedRows =
    operationalRows
      .filter(
        ({ summary }) =>
          summary.status ===
          "completed"
      )
      .map(
        ({ shift }) =>
          shift
      );

  const countStatus =
    (status) =>
      operationalRows.filter(
        ({ summary }) =>
          summary.status ===
          status
      ).length;

  const open =
    countStatus("open");

  const offered =
    countStatus("offered");

  const requested =
    countStatus("requested");

  const timeRequired =
    countStatus(
      "time_required"
    );

  const assigned =
    countStatus("assigned");

  const activated =
    countStatus("activated");

  const tracking =
    countStatus("tracking");

  const arrived =
    countStatus("arrived");

  const completed =
    countStatus("completed");

  const acceptedAssigned =
    operationalRows.filter(
      ({ summary }) =>
        summary.status ===
          "assigned" &&
        summary.accepted
    ).length;

  const awaitingAcceptance =
    operationalRows.filter(
      ({ summary }) =>
        summary.awaitingAcceptance
    ).length;

  const covered =
    operationalRows.filter(
      ({ summary }) =>
        summary.confirmedCoverage
    ).length;

  /*
   * Cancelled shifts are removed from demand.
   * Open, offered, requested, time-required,
   * awaiting-acceptance, no-show and
   * closed-unfilled remain demand but are not
   * confirmed coverage.
   */
  const demandRows =
    operationalRows.filter(
      ({ summary }) =>
        ![
          "cancelled",
          "canceled",
        ].includes(
          summary.status
        )
    );

  const total =
    demandRows.length;

  const coverage =
    total > 0
      ? Math.round(
          (covered / total) *
            100
        )
      : 100;

  const actualHours = completedRows.reduce((sum, s) => {
    const startMs = toMillis(s.startTime);
    const endMs = toMillis(s.completedAt || s.endTime);

    if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return sum;
    if (endMs <= startMs) return sum;

    return sum + (endMs - startMs) / 3600000;
  }, 0);

   return {
    coverage,

    total,
    covered,

    open,
    offered,
    requested,
    timeRequired,

    assigned,
    acceptedAssigned,
    awaitingAcceptance,

    activated,
    tracking,
    arrived,
    completed,

    actualHours,
    completedRows,
  };
}